export const floatingMenu = {
  floatingMenuHome: "首页",
  floatingMenuSlots: "老虎机",
  floatingMenuGames: "游戏",
  floatingMenuSports: "体育",
  floatingMenuLottery: "彩票",
  floatingMenuCasino: "赌场",
  floatingMenuFeed: "动态",
  floatingMenuBingo: "宾果",
  floatingMenuToPlay: "玩",
  floatingMenuCategories: "类别",
  floatingMenuSeeAllGames: "去所有游戏",
  floatingMenuSeeAllSports: "去所有体育",
};
